module.exports = __webpack_public_path__ + "comments/production/img/avatar.13d94e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.jpg
// module id = lS+k
// module chunks = 0